import React, { useRef, useState, useEffect, use } from 'react';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import { LeftIcon, RightIcon } from '../icons';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import { useRouter } from 'next/router';

const ProductComparison = () => {
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);
    const { t } = useLang('Delta3MaxSeriesStation.ProductComparison');
    const [isBeginning, setIsBeginning] = useState(true);
    const { locale = '' } = useRouter();
    const swiperRef = useRef<any>(null);
    const [isEnd, setIsEnd] = useState(false);
    const refA = useRef(null);
    const getContent = (index: number) => {
        const productList = [
            {
                label: '容量',
                value: ['2,048Wh', '2,048Wh', '2,048Wh'][index],
                textColor: ([] as number[]).includes(index),
            },
            {
                label: '重量',
                value: ['約22.1kg', '約20.3kg', '約23kg'][index],
                textColor: [0, 1].includes(index),
            },
            {
                label: '容量拡張',
                value: ['～10,240Wh', '不可', '～6,144Wh'][index],
                textColor: [0].includes(index),
            },
            {
                label: '定格出力',
                value: ['3,000W', '2,200W', '2,000W'][index],
                textColor: [0].includes(index),
            },
            {
                label: 'X-Boost',
                value: ['3,800W', '2,700W', '2,400W'][index],
                textColor: [0, 1].includes(index),
            },
            {
                label: 'ソーラー入力',
                value: ['1,000W（500W x2）', '500W', '1,000W（500W x2）'][index],
                textColor: ([] as number[]).includes(index),
            },
            {
                label: 'AC回路制御',
                value: ['対応', '-', '-'][index],
                textColor: [0].includes(index),
            },
            {
                label: '電源自動切り替え機能',
                value: ['<10ms', '<10ms', '<20ms'][index],
                textColor: [0, 1].includes(index),
            },
            {
                label: 'サイズ',
                value: ['49.4 × 24.2 × 30.5 cm', '49.4 × 23.9 × 30.5 cm', '49.7 × 24.2 × 30.5 cm'][index],
                textColor: ([] as number[]).includes(index),
            },
            {
                label: '保証期間',
                value: ['5年', '5年', '5年'][index],
                textColor: ([] as number[]).includes(index),
            },
        ];
        return productList;
    };

    const handlePushGtm = (productName: string, url: string) => {
        saveCookieForShopify(url, locale as string);
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: productName,
            position: `Collections_${productName}`,
        });
    };
    useEffect(() => {
        const listDomsC = (refA.current as any).querySelectorAll('.item-title');
        let minHeightC = 28;
        for (let i = 0; i < listDomsC.length; i++) {
            const elemA = listDomsC[i];
            const clientHeight = elemA.clientHeight;
            minHeightC = Math.max(minHeightC, clientHeight);
        }
        // 设置最小高度
        for (let i = 0; i < listDomsC.length; i++) {
            const elemA = listDomsC[i];
            elemA.style.minHeight = `${minHeightC}px`;
        }
    }, []);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
            } else if (window.innerWidth < 1024) {
                setSlidesOffset(48);
            } else if (window.innerWidth < 1340) {
                setSlidesOffset(120);
            } else {
                const offset = (window.innerWidth - 1200) / 2;
                setSlidesOffset(0);
            }
        }
    }, []);

    return (
        <section className={`${styles.ProductComparison} GtmModuleData-section`} data-section-id={'ProductComparison'} id="ProductComparison">
            <div className="title">{t('title')}</div>
            <div className="content" ref={refA}>
                <Swiper
                    slidesPerView={'auto'}
                    modules={[Navigation]}
                    spaceBetween={slidesOffset <= 24 ? 16 : 32}
                    slidesOffsetBefore={slidesOffset}
                    slidesOffsetAfter={slidesOffset}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);

                        setIsEnd(swiper.isEnd);
                    }}
                >
                    <SwiperSlide className="power-swiper-slide">
                        <ul>
                            <li className="item-set-li">
                                <div className="item-set">
                                    <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1757315221285/D3MP.png" />
                                </div>
                            </li>
                            <li className="text-color item-label">
                                <span>NEW</span>
                            </li>
                            <li className="item-title">
                                <span>{t('item1_d3mp')}</span>
                            </li>
                            <li className="item-btn">
                                <EcoButton
                                    className="buy-btn GtmModuleData-btn-href btn-1"
                                    lHref={saveCookieForShopify(`https://jp.ecoflow.com/products/delta-3-max-plus-portable-power-station`, locale)}
                                    lDataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: t('item1_d3mp'),
                                        position: `Collections_${t('item1_d3mp')}`,
                                        __btn_id1: `${styles.ProductComparison} .btn-1`,
                                        __btn_id2: saveCookieForShopify(`https://jp.ecoflow.com/products/delta-3-max-plus-portable-power-station`, locale),
                                        __btn_type: 'href',
                                    }}
                                >
                                    詳しくはこちら
                                </EcoButton>
                            </li>
                            <li className="item-dividing"></li>
                            {getContent(0).map((item, index) => (
                                <li key={index} className={`item-params`}>
                                    <span className={`item-value-params ${item.textColor ? 'text-color' : ''}`}>{item.value}</span>
                                    <span className="item-label-params">{item.label}</span>
                                </li>
                            ))}
                        </ul>
                    </SwiperSlide>
                    <SwiperSlide className="power-swiper-slide">
                        <ul>
                            <li className="item-set-li">
                                <div className="item-set">
                                    <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1757315221074/D3M.png" />
                                </div>
                            </li>
                            <li className="text-color item-label">
                                <span>NEW</span>
                            </li>
                            <li className="item-title">
                                <span>{t('item1_d3m')}</span>
                            </li>
                            <li className="item-btn">
                                <EcoButton
                                    className="buy-btn GtmModuleData-btn-href btn-2"
                                    lHref={saveCookieForShopify(`https://jp.ecoflow.com/products/delta-3-max-portable-power-station`, locale)}
                                    lDataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: t('item1_d3m'),
                                        position: `Collections_${t('item1_d3m')}`,
                                        __btn_id1: `${styles.ProductComparison} .btn-2`,
                                        __btn_id2: saveCookieForShopify(`https://jp.ecoflow.com/products/delta-3-max-portable-power-station`, locale),
                                        __btn_type: 'href',
                                    }}
                                >
                                    詳しくはこちら
                                </EcoButton>
                            </li>
                            <li className="item-dividing"></li>
                            {getContent(1).map((item, index) => (
                                <li key={index} className={`item-params`}>
                                    <span className={`item-value-params ${item.textColor ? 'text-color' : ''}`}>{item.value}</span>
                                    <span className="item-label-params">{item.label}</span>
                                </li>
                            ))}
                        </ul>
                    </SwiperSlide>
                    <SwiperSlide className="power-swiper-slide">
                        <ul>
                            <li className="item-set-li">
                                <div className="item-set">
                                    <EcoImg isOpenLazy pc="https://websiteoss.ecoflow.com/upload/image/1757315220888/D2M.png" />
                                </div>
                            </li>
                            <li className="text-color item-label">
                                <span></span>
                            </li>
                            <li className="item-title">
                                <span>{t('item1_d2m')}</span>
                            </li>
                            <li className="item-btn"></li>
                            <li className="item-dividing"></li>
                            {getContent(2).map((item, index) => (
                                <li key={index} className={`item-params`}>
                                    <span className={`item-value-params ${item.textColor ? 'text-color' : ''}`}>{item.value}</span>
                                    <span className="item-label-params">{item.label}</span>
                                </li>
                            ))}
                        </ul>
                    </SwiperSlide>
                </Swiper>
            </div>
            <div className="swiper-btn-box">
                <span className={`btn-item ${isBeginning ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slidePrev()}>
                    <LeftIcon />
                </span>
                <span className={`btn-item ${isEnd ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slideNext()}>
                    <RightIcon />
                </span>
            </div>
        </section>
    );
};

export default ProductComparison;
